import { Component, ViewChild, OnInit, OnDestroy, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AuthService } from '../../../../../services/auth.service';
import { IUntappd } from '../../../../../models/untappd';
import { UntappdExternalService } from '../../../../../services/external/untappdExternal.service';
import { UntapdSearchResult, IUntappdSearchResultBeer, Beer } from '../../../../../models/untappdExternal';
import { ModalController } from '@ionic/angular';
import { ExternalApiSettingsService } from '../../../../../services/dal/external-api-settings.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { SubscriptionHandler } from '../../../../../services/subscriptionHandler.service';
import { select, Store } from '@ngrx/store';
import * as fromExternalApiSettings from 'app/state/external-api-settings/reducer';

@Component({
  selector: 'app-search-untappd',
  templateUrl: './search-untappd.page.html',
  styleUrls: ['./search-untappd.page.scss'],
  standalone: true,
  imports: [FormsModule, IonicModule]
})
export class SearchUntappdPage {

  @Input() brewery!: string;
  @Input() beerName!: string;

  externalApiSettings = this.store.selectSignal(fromExternalApiSettings.selectItem);
  searchResult: UntapdSearchResult = {
    found: 0,
    beers: []
  };

  constructor(
    private store: Store,
    private modalController: ModalController,
    private untappdExternalService: UntappdExternalService,
  ) { }



  async dismiss(beer: Beer | null) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data

    if(beer)
    {
      const beerDetailsResponse = await firstValueFrom(
      this.untappdExternalService.getBeerInfo(
        this.externalApiSettings()?.untappd?.authToken ?? '',
        beer?.bid ?? -1)
      );

      this.modalController.dismiss({
        beerDetails: beerDetailsResponse.response.beer
      });
    }
    else {
      this.modalController.dismiss({
        beerDetails: null
      });
    }
    
  }


  search() {

    const queryParts: string[] = [];
    if (this.brewery?.trim()) {
      queryParts.push(this.brewery.trim());
    }
    if (this.beerName?.trim()) {
      queryParts.push(this.beerName.trim());
    }
    const query = queryParts.join(' ');

    if (!this.externalApiSettings()?.untappd?.authToken)
      return;

    this.untappdExternalService.search(this.externalApiSettings()?.untappd?.authToken ?? '', query).subscribe(result => {
      this.searchResult.found = result.response.found;
      result.response.homebrew.items.forEach(element => {

        this.searchResult.beers.push(
          {
            beer_label: element.beer.beer_label,
            auth_rating: element.beer.auth_rating,
            beer_abv: element.beer.beer_abv,
            beer_description: element.beer.beer_description,
            beer_ibu: element.beer.beer_ibu,
            beer_name: element.beer.beer_name,
            beer_slug: element.beer.beer_slug,
            beer_style: element.beer.beer_style,
            bid: element.beer.bid,
            created_at: element.beer.created_at,
            in_production: element.beer.in_production,
            wish_list: element.beer.wish_list,
          });
      });
      result.response.beers.items.forEach(element => {
        this.searchResult.beers.push(
          {
            beer_label: element.beer.beer_label,
            auth_rating: element.beer.auth_rating,
            beer_abv: element.beer.beer_abv,
            beer_description: element.beer.beer_description,
            beer_ibu: element.beer.beer_ibu,
            beer_name: element.beer.beer_name,
            beer_slug: element.beer.beer_slug,
            beer_style: element.beer.beer_style,
            bid: element.beer.bid,
            created_at: element.beer.created_at,
            in_production: element.beer.in_production,
            wish_list: element.beer.wish_list
          });
      });

    });


  }

}
